/*
  JOLI POT, note « bon à savoir » au-dessus du bouton d'ajout au panier (snippets/jp-note-achat.liquid).
  Ne crée aucun contenu : déplace dans l'encart les éléments existants, qui restent mis à jour par leurs scripts :
    #jp-delai (délai, jp-configurateur.js), .jp-liv (livraison offerte + barre, jp-configurateur.js),
    .jp-points[data-jp-points="produit"] (Jolis Points, jp-points.js, qui ne se re-déplace pas hors de la note).
  Une ligne n'apparaît que si son élément est visible ; la note suit l'état du bouton (masqué tant que les étapes
  ne sont pas remplies) et disparaît si aucune ligne n'est visible.
*/
(function () {
  if (window.jpNoteAchatPret) return;
  window.jpNoteAchatPret = true;

  var proto = Object.getOwnPropertyDescriptor(Node.prototype, 'previousSibling');

  function bouton(form) { return form.querySelector('.ProductForm__AddToCart'); }

  function visible(el) {
    if (!el || el.hidden || el.classList.contains('jp-cache')) return false;
    return window.getComputedStyle(el).display !== 'none';
  }

  /* jp-configurateur.js replace l'encadré livraison juste après le bouton s'il n'y est pas
     (test « livEl.previousSibling !== bouton »). Dans la note, on lui répond que le bouton est bien
     son voisin : il garde la main sur le texte, la barre et l'affichage, sans le ressortir de la note. */
  function caler(liv) {
    if (liv.__jpna || !proto || !proto.get) return;
    liv.__jpna = true;
    try {
      Object.defineProperty(liv, 'previousSibling', {
        configurable: true,
        get: function () {
          if (this.closest && this.closest('[data-jp-note-achat]')) {
            var f = this.closest('form'), b = f && bouton(f);
            if (b) return b;
          }
          return proto.get.call(this);
        }
      });
    } catch (e) {}
  }

  /* Date du délai : la seconde ligne (« entre le ... et le ... ») est l'élément mis en avant */
  function marquerDate(delai) {
    var zd = delai.querySelector('#jp-delai-date');
    if (!zd || zd.querySelector('.jpna__fort') || zd.hidden) return;
    var br = zd.querySelector('br');
    var t = br && br.nextSibling;
    if (!t || t.nodeType !== 3 || !t.nodeValue.trim()) return;
    var s = document.createElement('span');
    s.className = 'jpna__fort';
    zd.insertBefore(s, t);
    s.appendChild(t);
  }

  function ranger(note, cle, el) {
    var ligne = note.querySelector('[data-jpna="' + cle + '"]');
    if (!ligne) return false;
    var corps = ligne.querySelector('.jpna__corps');
    if (el && el.parentNode !== corps) corps.appendChild(el);
    var vu = !!el && visible(el);
    if (ligne.hidden === vu) ligne.hidden = !vu;
    return vu;
  }

  var attente = false;
  function maj() {
    attente = false;
    var modele = document.getElementById('jp-note-achat-modele');
    var form = document.querySelector('form.jp-produit-form');
    if (!modele || !form) return;
    var bp = bouton(form);
    if (!bp || !bp.parentNode) return;
    var note = form.querySelector('[data-jp-note-achat]');
    if (!note) {
      note = (modele.content ? modele.content.firstElementChild : modele.firstElementChild).cloneNode(true);
    }
    if (note.parentNode !== bp.parentNode || note.nextElementSibling !== bp) bp.parentNode.insertBefore(note, bp);

    var delai = document.getElementById('jp-delai');
    var liv = form.querySelector('.jp-liv') || document.querySelector('.jp-liv');
    var pts = document.querySelector('.jp-points[data-jp-points="produit"]');
    if (delai) marquerDate(delai);
    if (liv) caler(liv);

    var a = ranger(note, 'delai', delai);
    var b = ranger(note, 'liv', liv);
    var c = ranger(note, 'points', pts);
    var montrer = (a || b || c) && visible(bp);
    if (note.hidden === montrer) note.hidden = !montrer;
  }
  function plusTard() {
    if (attente) return;
    attente = true;
    (window.requestAnimationFrame || setTimeout)(maj);
  }

  function demarrer() {
    maj();
    if (window.MutationObserver) {
      /* les redessins de l'aperçu du pot (.jp-ap) ne changent rien à la note : ignorés */
      new MutationObserver(function (l) { for (var k = 0; k < l.length; k++) { var e = l[k].target; e = e.nodeType === 1 ? e : e.parentNode; if (e && e.closest && e.closest('.jp-ap')) continue; plusTard(); return; } }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
    }
    document.addEventListener('variant:change', plusTard);
    window.addEventListener('resize', plusTard);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
